import { render, staticRenderFns } from "./LinksSubmenu.vue?vue&type=template&id=509b3ec6&"
import script from "./LinksSubmenu.vue?vue&type=script&lang=js&"
export * from "./LinksSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./LinksSubmenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports